<template>
  <div class="footer">
    <BaseFooter />
    <div class="billing" :class="$mq">
      <img src="@/assets/images/footer/billing.png" alt="" />
    </div>
    <BasePress />
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.footer {
  padding-block: 2em;
  background-color: white;
  .billing {
    text-align: center;
    &.sm,
    &.md {
      padding-inline: 2em;
      img {
        width: 100%;
      }
    }
  }
}
</style>
